import config from "@src/config";
import { UserProvider as VividUserProvider } from "@vivid/react-oidc-client";
import * as Oidc from "oidc-client";
import { type ComponentProps, type ComponentType, type FunctionComponent, type PropsWithChildren, type ReactNode } from "react";

const UserProvider = VividUserProvider as ComponentType<ComponentProps<typeof VividUserProvider> & { children?: ReactNode }>;

export const userService = new Oidc.UserManager({
    authority: config.IDP_URL,
    client_id: "reviermanager-admin",
    redirect_uri: `${config.ADMIN_URL}/process-token`,
    response_type: "code",
    scope: "offline openid profile email role",
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    post_logout_redirect_uri: location.origin,
    revokeAccessTokenOnSignout: true,
    automaticSilentRenew: true,
});
// Oidc.Log.logger = console;

const CustomUserProvider: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <UserProvider
        userManager={userService}
        postLoginRedirectUri="/"
        accessTokenCookieName="oidc.access_token"
        accessTokenCookieOptions={{
            domain: new URL(config.API_URL).hostname.replace(/^[^.]+\./g, ""),
            sameSite: "Lax",
            path: "/images/preview",
        }}
    >
        {children}
    </UserProvider>
);

export default CustomUserProvider;
